module.exports = __webpack_public_path__ + "static/media/sad-fill.bd8128d9.svg";